import { THEME_BORDER_RADIUS, radius } from '@gef-ui/material-theme-utils';
import { csCZ } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import breakpoints from './breakpoints';
import componentsOverride from './overrides';
import palette from './palette';
import shadows, { customShadows } from './shadows';
import typography from './typography';
const defaultMerge = (arg)=>arg;
const setupTheme = (preprocessor, postprocessor, direction, locale, modes = [
    'light',
    'dark'
])=>{
    const theme = createTheme(preprocessor({
        colorSchemes: {
            ...modes.includes('light') && {
                light: {
                    palette: palette.light
                }
            },
            ...modes.includes('dark') && {
                dark: {
                    palette: palette.dark
                }
            }
        },
        typography,
        breakpoints,
        radius,
        shape: {
            borderRadius: THEME_BORDER_RADIUS
        },
        direction
    }));
    if (modes.includes('light')) {
        theme.colorSchemes.light = {
            ...theme.colorSchemes.light,
            shadows: shadows.light,
            customShadows: customShadows.light,
            isLight: true
        };
        theme.colorSchemes.light.components = deepmerge(locale?.components, componentsOverride({
            ...theme,
            palette: palette.light,
            shadows: shadows.light,
            customShadows: customShadows.light
        }));
    }
    if (modes.includes('dark')) {
        theme.colorSchemes.dark = {
            ...theme.colorSchemes.dark,
            shadows: shadows.dark,
            customShadows: customShadows.dark,
            isLight: false
        };
        theme.colorSchemes.dark.components = deepmerge(locale?.components, componentsOverride({
            ...theme,
            palette: palette.dark,
            shadows: shadows.dark,
            customShadows: customShadows.dark
        }));
    }
    theme.type = 'internal';
    theme.isExternal = false;
    return {
        ...theme,
        colorSchemes: {
            ...theme.colorSchemes,
            ...modes.includes('light') && {
                light: postprocessor(theme.colorSchemes.light)
            },
            ...modes.includes('dark') && {
                dark: postprocessor(theme.colorSchemes.dark)
            }
        }
    };
};
export default (({ direction = 'ltr', preprocessor = defaultMerge, postprocessor = defaultMerge, locale = csCZ, modes = [
    'light',
    'dark'
] } = {})=>{
    const theme = setupTheme(preprocessor, postprocessor, direction, locale, modes);
    return theme;
});
